import { useState } from 'react';
import ArticleLink from '@/components/feature/ArticleLink';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';
import { orderTypeGuides } from '@/mocks/forexTrading';

export default function OrderTypeGuide() {
  const [activeKey, setActiveKey] = useState(orderTypeGuides[0].key);
  const active = orderTypeGuides.find((item) => item.key === activeKey) ?? orderTypeGuides[0];

  return (
    <section className="border-y border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="ประเภทคำสั่ง"
          title="จะเข้าตลาดด้วยคำสั่งแบบไหน"
          subtitle="การเลือกคำสั่งคือการเลือกว่าจะเข้าตอนนี้ หรือรอราคามาถึงจุดที่ต้องการก่อน ซึ่งส่งผลต่อราคาที่ได้และวินัยในการเทรด"
        />

        <div className="mt-8 inline-flex max-w-full gap-1 overflow-x-auto rounded-full border border-background-200 bg-background-100/70 px-1 py-1 no-scrollbar">
          {orderTypeGuides.map((item) => {
            const isActive = item.key === activeKey;
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => setActiveKey(item.key)}
                aria-pressed={isActive}
                className={`flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-50 hover:text-foreground-950'
                }`}
              >
                <i className={`${item.icon} text-base`} />
                {item.name}
              </button>
            );
          })}
        </div>

        <ScrollReveal className="mt-6">
          <div className="grid grid-cols-1 gap-6 rounded-xl border border-background-200 bg-background-100/50 p-5 md:p-7 lg:grid-cols-[1.15fr_1fr]">
            <div className="min-w-0">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${active.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">{active.name}</h3>
                  <p className="text-sm text-foreground-600">{active.thai}</p>
                </div>
              </div>

              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{active.when}</p>

              <div className="mt-4 rounded-lg border border-background-300 border-l-2 border-l-primary-500 bg-background-50 px-4 py-3">
                <p className="flex items-center gap-2 text-xs font-semibold text-foreground-800">
                  <i className="ri-crosshair-2-line text-primary-600" />
                  ราคาที่คำสั่งจะถูกจับคู่
                </p>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{active.entry}</p>
              </div>

              <ArticleLink
                to="/forex-order-types"
                className="mt-5 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-primary-700 transition-colors hover:text-primary-900"
              >
                อ่านบทความเรื่องประเภทคำสั่ง
                <i className="ri-arrow-right-line text-base" />
              </ArticleLink>
            </div>

            <div className="flex min-w-0 flex-col gap-4">
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="flex items-center gap-2 text-xs font-semibold text-primary-700">
                  <i className="ri-check-double-line text-base" />
                  ข้อดีที่ได้
                </p>
                <ul className="mt-2.5 flex flex-col gap-2">
                  {active.pros.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm leading-snug text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-primary-600" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <p className="flex items-center gap-2 text-xs font-semibold text-accent-700">
                  <i className="ri-error-warning-line text-base" />
                  ต้องระวัง
                </p>
                <ul className="mt-2.5 flex flex-col gap-2">
                  {active.cautions.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm leading-snug text-foreground-700">
                      <i className="ri-subtract-line mt-0.5 text-accent-600" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}